import { configureAiCommentaryPage } from './pdf-commentary-page.js';
import { configureMemoryPassagePage } from './pdf-memory-page.js';
import { configureStudentPage } from './pdf-student-page.js';
import { configureTeacherPage } from './pdf-teacher-page.js';
/**
 * Render a SKJV study lesson PDF. Returns an ArrayBuffer (jspdf's canonical
 * binary container) — callers wrap in a Blob (browser) or Buffer (Node) as
 * needed.
 */
export async function generateStudyPdfBytes(opts) {
    const { jsPDF } = await import('jspdf');
    const doc = new jsPDF();
    const { study, studyGroup, verseTextSource: vts } = opts;
    // A single teacher is always implied: a group with no teachers listed
    // still prints one (generic) teacher sheet; listed teachers get one each.
    const teachers = studyGroup?.teachers?.length
        ? studyGroup.teachers
        : [{ id: 'implied-teacher', name: 'Teacher' }];
    const hasMemoryPassage = !!studyGroup?.memoryStartingLocation;
    for (const teacher of teachers) {
        await configureTeacherPage(doc, study, vts, studyGroup, teacher);
        if (hasMemoryPassage) {
            doc.addPage();
            await configureMemoryPassagePage(doc, teacher, studyGroup, vts);
        }
        doc.addPage();
    }
    for (let i = 0; i < study.assignments.length; i++) {
        await configureStudentPage(doc, study, study.assignments[i], vts);
        if (hasMemoryPassage) {
            const student = studyGroup.students.find((s) => s.id === study.assignments[i].student.id) ||
                study.assignments[i].student;
            doc.addPage();
            await configureMemoryPassagePage(doc, student, studyGroup, vts);
        }
        if (i < study.assignments.length - 1) {
            doc.addPage();
        }
    }
    // Optional AI pericope commentary — always the LAST page when attached.
    if (study.aiCommentary) {
        doc.addPage();
        await configureAiCommentaryPage(doc, study, vts);
    }
    return doc.output('arraybuffer');
}
//# sourceMappingURL=generate-study-pdf.js.map